import { createSelector } from 'reselect';
import precise from '../modules/precise';
import { VEHICLES } from '../modules/constants';

const SVCFeesTotalSelector = state => state.registration.SVCFEE_TOTAL;
const BaseFeeSelector = state => state.registration.BaseFee;
const selectedVehicleTypeSel = state => state.registration.selectedVehicleType;

// Rsub1a
const totalBaseAndSVCFee = createSelector(
  [SVCFeesTotalSelector, BaseFeeSelector, selectedVehicleTypeSel],
  (svc, base, selectedVehicleType) => {
    if (selectedVehicleType === VEHICLES.BUSES_TRAILER) {
      base = 0;
    }

    return precise(Number(svc) + Number(base));
  },
);

export default totalBaseAndSVCFee;
